import './assets/main.css'
import { createApp } from 'vue'
import App from './App.vue'
import { setupI18n } from './locales/setup'
import TDesign from 'tdesign-vue-next'
import 'tdesign-vue-next/es/style/index.css'
import './styles/theme.less'
import './styles/global.less'
import './styles/fix.less'
import { store } from './store'
import { setupRouter } from './router'
import { VueQueryPlugin } from '@tanstack/vue-query'
import type { VueQueryPluginOptions } from '@tanstack/vue-query'

import microApp from '@micro-zoe/micro-app'
import { setupCustomComponent } from './components'

// TODO：需要把微前端的方案解决
microApp.start({
  iframe: true, // 全局开启iframe沙箱，默认为false
  inline: true, // 全局开启内联script模式运行js，默认为false
  'keep-alive': true,
  plugins: {
    modules: {
      'my-app': [
        {
          loader(code) {
            return code
          }
        }
      ]
    }
  }
})

const vueQueryPluginOptions: VueQueryPluginOptions = {
  queryClientConfig: {
    defaultOptions: {
      queries: {
        retry: false
      }
    }
  }
}

const setup = async () => {
  const app = createApp(App)

  await setupI18n(app)

  setupRouter(app)

  app.use(TDesign as any)
  app.use(store)
  app.use(VueQueryPlugin, vueQueryPluginOptions)
  setupCustomComponent(app)
  app.mount('#app')
}

setup()
